import vue from 'vue'

const state = {
  scMenu: vue.ls.get('scMenu'),
}

const getters = {
  scMenu: () => state.scMenu ? state.scMenu : vue.ls.get('scMenu'),
}

const actions = {}

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'scMenu') {
      vue.ls.set(payload.state, payload.update);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/file/modules/systemContent.js